import { ChatGlyph } from '../ChatInterface/ChatGlyph'
import { IconButton } from '@chakra-ui/react'
import React from 'react'

interface SidebarToggleButtonProps {
  isOpen: boolean
  onToggle?: () => void
  isFloating?: boolean
}

const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({ isOpen, onToggle, isFloating = false }) => {
  // While the sidebar is open, its control lives in the sidebar header.
  if (isFloating && isOpen) return null

  return (
    <IconButton
      aria-label={isOpen ? 'Close sidebar' : 'Open sidebar'}
      icon={<ChatGlyph name={isOpen ? 'collapse' : 'expand'} />}
      onClick={onToggle || (() => undefined)}
      position={isFloating ? 'fixed' : 'static'}
      top={3}
      left={3}
      variant='unstyled'
      color='chat.muted'
      zIndex={isFloating ? 1001 : 10}
      minW={{ base: 12, md: 9 }}
      h={{ base: 12, md: 9 }}
      bg='transparent'
      borderRadius='chat.sm'
      p={2}
      display='flex'
      alignItems='center'
      justifyContent='center'
      _hover={{ opacity: 0.8 }}
      _focusVisible={{ outline: '2px solid', outlineColor: 'chat.focus', outlineOffset: '2px' }}
      _active={{
        color: 'gray.800',
      }}
    />
  )
}

export default SidebarToggleButton
